var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheckFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#17B26A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_4595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2296 8.17488L10.333 16.0709C10.2799 16.1242 10.2168 16.1665 10.1473 16.1953C10.0779 16.2242 10.0034 16.239 9.92815 16.239C9.85292 16.239 9.77843 16.2242 9.70895 16.1953C9.63948 16.1665 9.57638 16.1242 9.52329 16.0709L6.46958 13.0143C6.41649 12.961 6.35339 12.9187 6.28392 12.8899C6.21444 12.861 6.13995 12.8461 6.06472 12.8461C5.98949 12.8461 5.915 12.861 5.84552 12.8899C5.77605 12.9187 5.71296 12.961 5.65986 13.0143V13.0143C5.60656 13.0674 5.56427 13.1305 5.53541 13.2C5.50655 13.2694 5.4917 13.3439 5.4917 13.4192C5.4917 13.4944 5.50655 13.5689 5.53541 13.6384C5.56427 13.7078 5.60656 13.7709 5.65986 13.824L8.71472 16.8783C9.03698 17.2 9.47369 17.3806 9.92901 17.3806C10.3843 17.3806 10.821 17.2 11.1433 16.8783L19.0393 8.98402C19.0925 8.93094 19.1347 8.86788 19.1635 8.79846C19.1923 8.72904 19.2072 8.65461 19.2072 8.57945C19.2072 8.50429 19.1923 8.42986 19.1635 8.36044C19.1347 8.29102 19.0925 8.22796 19.0393 8.17488C18.9862 8.12158 18.9231 8.07929 18.8536 8.05043C18.7842 8.02157 18.7097 8.00671 18.6344 8.00671C18.5592 8.00671 18.4847 8.02157 18.4152 8.05043C18.3458 8.07929 18.2827 8.12158 18.2296 8.17488Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_4595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    fill: "white",
    transform: "translate(5.47583 5.64285)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckFill);
export default __webpack_public_path__ + "static/media/green-check-fill.976fd454f2a8e27e1fa22649abd4e9c8.svg";
export { ForwardRef as ReactComponent };